<div class="page-home">

   <section class="banner desktop" #bannerElement>
      <div class="title">
         <img #h1Title src="assets/images/logo_dom436.png" alt="DOM 436" />
      </div>
      <div class="row">
         <div class="col-lg-4 infos">
            <div class="container">
               <div class="details" #detailsElement>
                  <div class="row">
                     <p>
                        Its is seen from two perspectives, museological and contextual.
                     </p>
                  </div>
                  <div class="row">
                     <a [routerLink]="['/selecionar-apartamento']" class="link-configurator">Decorador <img src="assets/images/arrow-right-white.png" /></a>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-lg-8 image">
            <img src="assets/images/home_banner.jpg" alt="DOM 436" />
            <div class="down-arrow bounce">
               <a [routerLink]="['/']" fragment="galeria"><img alt="Seta" src="assets/images/arrow-down-white.png" /></a>
             </div>
         </div>
      </div>
   </section>

   <section class="banner mobile">
      <div class="title">
         <img #h1Title src="assets/images/logo_dom436.png" alt="DOM 436" />
      </div>
      <img src="assets/images/home_banner-mobile.jpg" alt="DOM 436" />
      <div class="row">
         <div class="infos">
            <div class="container">
               <div class="details">
                  <div class="row">
                     <p>
                        Its is seen from two perspectives, museological and contextual.
                     </p>
                  </div>
                  <div class="row">
                     <div class="area-configurator">
                        <a [routerLink]="['/selecionar-apartamento']" class="link-configurator">Decorador <img src="assets/images/arrow-right-white.png" /></a>
                     </div>
                     <div class="area-arrow">
                        <div class="down-arrow bounce">
                           <a [routerLink]="['/']" fragment="galeria"><img alt="Seta" src="assets/images/arrow-down-white.png" /></a>
                         </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
   
   <section id="galeria" class="gallery" #galleryElement>
      <div class="container">
         <div class="row">
            <div class="section-title" #galleryTitleElement>
               <a [routerLink]="['/']" fragment="galeria"><h2>Conheça o DOM436</h2></a>
            </div>
            <div class="section-content" #galleryContentElement>
               <div class="slide">
                  <owl-carousel-o [options]="carouselOptions">
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_1.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_2.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_3.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_4.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_5.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_6.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_7.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_8.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_9.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_10.jpg" alt="Slide de Imagens" />
                     </ng-template>
                     <ng-template carouselSlide>
                        <img src="assets/images/Halma-199_11.jpg" alt="Slide de Imagens" />
                     </ng-template>
                  </owl-carousel-o>
               </div>
               <div class="section-title slide-area" #galleryTitleElement>
                  <a [routerLink]="['/']" fragment="galeria"><h2>Galeria</h2></a>
               </div>
               <div class="decorator-link">
                  <a [routerLink]="['/selecionar-apartamento']" class="link-configurator">Decore o seu <img src="assets/images/arrow-right-black.svg" /></a>
               </div>
               <div class="description">
                  <div class="row">
                     <div class="col-lg-5"></div>
                     <div class="col-lg-7">
                        <h3>Its is seen from two perspectives, museological and contextual.</h3>
                        <p>
                           Situated amongst the mountain ranges nearby the Miyun Reservoir, the center aims 
                           to encourage visitors to engage with the landscape. Taking inspiration form the local area, 
                           the renowned architechture firm has created a cultural facility that blends traditional 
                           and contemporary architecture.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
   <section id="apartamentos" class="apartments" #apartmentsElement>
      <div class="container">
         <div class="row">
            <div class="section-title" #apartmentsTitleElement>
               <a (click)="navegarApartamentos()" [routerLink]="['/']" fragment="apartamentos"><h2>Plantas</h2></a>
            </div>
            <div class="section-content" #apartmentsContentElement>
               <div *ngFor="let planta of plantas" class="apartment col-md-6">
                  <div *ngIf="planta.id != 3 && planta.id != 4">
                     <div class="row">
                        <div class="col-lg-12">
                           <div class="apatmentimg">
                              <img src="{{caminhoImg+planta.imagem}}" alt="{{planta.nome}}" />
                           </div>
                        </div>
                     </div>
                     <div class="row">
                           <div class="col-lg-6">
                              <p>{{planta.nome}}</p>
                              <p>{{planta.metragem.valor}}m²</p>
                           </div>
                           <div class="col-lg-6">
                              <a [routerLink]="['/selecionar-apartamento']" [state]="{selectedMetragem: planta.metragem}" class="link-configurator">Decore o seu <img src="assets/images/arrow-right-black.svg" /></a>
                           </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
   <section id="localizacao" class="location" #locationElement>
      <div class="container">
         <div class="row">
            <div class="section-title" #locationTitleElement>
               <a (click)="navegarLocalizacao()" [routerLink]="['/']" fragment="localizacao"><h2>Localização</h2></a>
            </div>
            <div class="section-content" #locationContentElement>
               <div class="map-img">
                  <img src="assets/images/home_map.jpg" alt="Mapa Localização do DOM 436" />
               </div>
               <div class="contact_map">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.2960374723707!2d-47.04229748443129!3d-22.90244924347531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c8cf400c8c5003%3A0x806581b2eaf8bd78!2sR.%20Dom%20Francisco%20de%20Campos%20Barreto%2C%20436%20-%20Nova%20Campinas%2C%20Campinas%20-%20SP%2C%2013092-160!5e0!3m2!1spt-BR!2sbr!4v1612477031217!5m2!1spt-BR!2sbr" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
               </div>
            </div>
         </div>
      </div>
   </section>
   
   <section class="about" #aboutElement>
      <div class="container">
         <div class="row">
            <div class="col-lg-6">
               <div class="description">
                  <h3>Its is seen from two perspectives, museological and contextual.</h3>
                  <p>
                     Situated amongst the mountain ranges nearby the Miyun Reservoir, the center aims 
                     to encourage visitors to engage with the landscape. Taking inspiration form the local area, 
                     the renowned architechture firm has created a cultural facility that blends traditional 
                     and contemporary architecture.
                  </p>
               </div>
            </div>
            <div class="col-lg-6"></div>
         </div>
         <div class="row">
            <div class="col-lg-6">
               <div class="footer-links">
                  <a [routerLink]="['/']" fragment="galeria" class="link-configurator">Galeria <img src="assets/images/arrow-right-white.png" /></a>
                  <a [routerLink]="['/']" fragment="apartamentos" class="link-configurator">Plantas <img src="assets/images/arrow-right-white.png" /></a>
                  <a [routerLink]="['/selecionar-apartamento']" class="link-configurator">Decorador <img src="assets/images/arrow-right-white.png" /></a>
               </div>
            </div>
            <div class="col-lg-6">
               <div class="copyright">
                  <a (click)="voltarTopo()" [routerLink]="['/']" class="link-backtotop">Voltar ao topo <img src="assets/images/arrow-top-white.png" /></a>
                  <span>©2021</span>
               </div>
            </div>
         </div>
         <div class="title-bottom">
            <img #h1Title src="assets/images/logo_dom436-footer.png" alt="DOM 436" />
         </div>
      </div>
   </section>

</div>
